interface AnalyticsLinkButtonProps {
  href: string;
  subject: string;
  label?: string;
  className?: string;
}

const AnalyticsLinkButton = ({
  href,
  subject,
  label = "View Analytics",
  className = "",
}: AnalyticsLinkButtonProps) => {
  const styles =
    "shrink-0 inline-flex items-center rounded-md border border-[#D4D3C5] bg-transparent px-2.5 py-1.5 font-mulish text-xs font-bold whitespace-nowrap transition-colors text-[#28543D] hover:text-[#28543D] focus-visible:text-[#28543D] hover:bg-[#EEF0E3] focus-visible:bg-[#EEF0E3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#28543D]";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${label} for ${subject} (opens in a new tab)`}
      className={`${styles} ${className}`}
    >
      {label}
    </a>
  );
};

export default AnalyticsLinkButton;
